import moment from 'moment'

function timeAgo(value) {
  const date = moment(value)
  const now = moment()
  const diff = now.diff(date)
  const diffDuration = moment.duration(diff)

  if (diff < 60000) {
    return 'Just now'
  } else if (diffDuration.asMinutes() < 60) {
    const minutes = diffDuration.asMinutes().toFixed(0)
    return `${minutes} ${minutes > 1 ? 'minutes' : 'minute'} ago`
  } else if (diffDuration.asHours() < 24) {
    const hours = diffDuration.asHours().toFixed(0)
    return `${hours} ${hours > 1 ? 'hours' : 'hour'} ago`
  } else if (diffDuration.asDays() < 7) {
    const days = diffDuration.asDays().toFixed(0)
    return `${days} ${days > 1 ? 'days' : 'day'} ago`
  } else if (diffDuration.asWeeks() < 4) {
    const weeks = diffDuration.asWeeks().toFixed(0)
    return `${weeks} ${weeks > 1 ? 'weeks' : 'week'} ago`
  } else if (diffDuration.asMonths() < 12) {
    const months = diffDuration.asMonths().toFixed(0)
    return `${months} ${months > 1 ? 'months' : 'month'} ago`
  } else {
    return 'Long ago'
  }
}

function daysLeft(value) {
  const date = moment(value)
  const now = moment()
  const diff = date.diff(now, 'hours') // Calculate the difference in hours

  if (diff < 0) {
    return 'Expired'
  } else if (diff < 24) {
    return 'Tomorrow'
  } else {
    const days = Math.floor(diff / 24) // Calculate the number of days left
    return `${days} ${days > 1 ? 'days' : 'day'} left`
  }
}

function commaValue(value, sign) {
  const testVal = value !== undefined && value !== null && typeof value === 'number'

  if (testVal) {
    const whole = Math.abs(Math.trunc(value)).toString()
    const newstr = []
    for (let i = whole.length; i > 0; i -= 3) {
      newstr.unshift(whole.substring(i, i - 3))
    }
    if (value < 0) {
      return `-${newstr.join(',')}` + (sign !== undefined ? ` ${sign}` : '')
    } else {
      return `${newstr.join(',')}` + (sign !== undefined ? ` ${sign}` : '')
    }
  } else {
    return '0.00' + (sign !== undefined ? ` ${sign}` : '')
  }
}

export {
  timeAgo,
  daysLeft,
  commaValue,
}
